import React from "react";
import ModalTemplate from "../modal-template";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import { useNavigate } from "react-router-dom";

interface IProps {
  close: () => void;
}
const UploadMediaModal = ({ close }: IProps) => {
  const navigate = useNavigate();
  return (
    <ModalTemplate
      close={close}
      confirm={() => {}}
      header="Upload"
      footer={false}
    >
      <ButtonItem onClick={() => navigate("/overview/upload-music")}>
        <IconContainer>
          <Icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M10.833 13.0002V9.66683V6.3335"
                stroke="white"
                stroke-linecap="round"
              />
              <path
                d="M9.16667 14.6668C10.0871 14.6668 10.8333 13.9206 10.8333 13.0002C10.8333 12.0797 10.0871 11.3335 9.16667 11.3335C8.24619 11.3335 7.5 12.0797 7.5 13.0002C7.5 13.9206 8.24619 14.6668 9.16667 14.6668Z"
                stroke="white"
              />
              <path
                d="M13.333 8.8335C11.9523 8.8335 10.833 7.7142 10.833 6.3335"
                stroke="white"
                stroke-linecap="round"
              />
              <path
                d="M11.667 18.6665C11.1285 18.7758 10.5711 18.8332 10.0003 18.8332C5.39795 18.8332 1.66699 15.1022 1.66699 10.4998C1.66699 5.89746 5.39795 2.1665 10.0003 2.1665C14.6027 2.1665 18.3337 5.89746 18.3337 10.4998C18.3337 11.0706 18.2762 11.628 18.167 12.1665"
                stroke="white"
                stroke-linecap="round"
              />
              <path
                d="M15.0003 18.8333V13M15.0003 13L17.0837 15.0833M15.0003 13L12.917 15.0833"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Icon>
        </IconContainer>
        <TextArea>
          <Typography size="lg" mb="0.4" color={Colors.grey400} weight="medium">
            Upload Music
          </Typography>
          <Typography size="s" color={Colors.grey500}>
            Create a new audio track
          </Typography>
        </TextArea>
      </ButtonItem>
      <ButtonItem onClick={() => navigate("/overview/upload-video")}>
        <IconContainer>
          <Icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M10.0003 2.1665C13.9287 2.1665 15.8929 2.1665 17.1132 3.3869C18.3337 4.60728 18.3337 6.57146 18.3337 10.4998C18.3337 14.4282 18.3337 16.3924 17.1132 17.6128C15.8929 18.8332 13.9287 18.8332 10.0003 18.8332C6.07195 18.8332 4.10777 18.8332 2.88738 17.6128C1.66699 16.3924 1.66699 14.4282 1.66699 10.4998C1.66699 6.57146 1.66699 4.60728 2.88738 3.3869C4.10777 2.1665 6.07195 2.1665 10.0003 2.1665Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M17.9163 14.6665H2.08301"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M17.9163 6.3335H2.08301"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M10 2.1665V6.33317M10 18.8332V14.6665"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M14.167 2.5835V6.3335M14.167 18.4168V14.6668"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M5.83301 2.5835V6.3335M5.83301 18.4168V14.6668"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M11.6663 10.4998C11.6663 10.06 11.225 9.76334 10.3423 9.17009C9.44759 8.56876 9.00017 8.26809 8.66659 8.48885C8.33301 8.70962 8.33301 9.30634 8.33301 10.4998C8.33301 11.6933 8.33301 12.2901 8.66659 12.5108C9.00017 12.7316 9.44759 12.4309 10.3423 11.8296C11.225 11.2363 11.6663 10.9397 11.6663 10.4998Z"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </Icon>
        </IconContainer>
        <TextArea>
          <Typography size="lg" mb="0.4" color={Colors.grey400} weight="medium">
            Upload Video
          </Typography>
          <Typography size="s" color={Colors.grey500}>
            Release your music video
          </Typography>
        </TextArea>
      </ButtonItem>
    </ModalTemplate>
  );
};

export default UploadMediaModal;

const ButtonItem = styled.div`
  cursor: pointer;
  width: 100%;
  padding: 0.8rem;
  border-radius: 0.8rem;
  background-color: ${Colors.grey900};
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  min-width: 40rem;
`;

const IconContainer = styled.div`
  width: 4rem;
  height: 4rem;
  margin-right: 0.8rem;
  background-color: ${Colors.grey700};
  border-radius: 0.4rem;
  border: 1px solid #4e4e4e;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Icon = styled.div`
  width: 2rem;
  height: 2rem;
`;
const TextArea = styled.div``;
